<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="rank-reward-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <p class="notice">奖励将于9月28日起30个工作日内发放。</p>

                    <div class="rank-wrapper">
                        <vuescroll>
                        <div class="rank-view">                       
                            <div class="rank-pannel">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,index) in rankData" :key="index" :class="{'odd' : index % 2 == 0}">
                                            <th class="rank-name">{{ item.name }}</th>
                                            <th>
                                                <div class="reward-list">
                                                    <div class="r-item" v-for="(r,k) in item.reward" :key="k">
                                                        <div class="pic">
                                                            <div class="icon"><img :src="require('@/assets/images/'+ r +'.jpg')" alt="" srcset=""></div>
                                                        </div>
                                                        <p class="itemname">{{ item.itemname[k] }}</p>
                                                    </div>
                                                </div>
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        </vuescroll>
                    </div>

                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.rank-reward-modal{
    position: relative;
    width: 715px;
        height: 807px;
        font-size: 24px;
        color: #8e492e;
        background-image: url(~@/assets/images/bg-rule.png);
}

.title{
    width: 319px;
    height: 60px;
    margin: 15px auto 40px;
    background-image: url(~@/assets/images/title-rank.png);     
}

.rank-wrapper{
    width: 640px;
    height: 580px;
    padding: 0 10px;
    margin: 0 auto;
}

.rank-pannel{
    /* height: 1162px; */
    margin: 0 auto;
    /* background-image: url(~@/assets/images/bg-rank-reward-table.png);    */
}

.rank-pannel table{
    width: 100%;
    font-weight: 400;
}

.rank-pannel th{
    font-weight: 400;
}

.rank-pannel tr.odd{
    background-color: #f0d4aa;
}

.reward-list{
    display: flex;
    width: 500px;
    padding-top: 12px;
    justify-content: space-evenly;
}

.notice{
    text-align: center;
    margin-bottom: 5px;
}

.rank-name{
    width: 139px;
    height: 160px;
}

.itemname{
    width: 150px;
    margin: 0 auto;
    font-size: 20px;
}

</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            rankData : [{
                name : '第1名',
                reward: ['C001','C002','C003'],
                itemname : ['10000绑定梦三币','动态称号*天鸡不可泄露（90天）','虎牙直播鸡王奖励包']
            },{
                name : '第2名',
                reward: ['C001','C002','C003'],
                itemname : ['8000绑定梦三币','动态称号*天鸡不可泄露（90天）','虎牙直播亚军奖励包']                
            },{
                name : '第3名',
                reward: ['C001','C002','C003'],
                itemname : ['5000绑定梦三币','动态称号*天鸡不可泄露（90天）','虎牙直播季军奖励包']                      
            },{
                name : '第4-10名',
                reward: ['C001','C004','C003'],
                itemname : ['3000绑定梦三币','勋章*威震华夏（30天）','虎牙直播优胜奖励包']                      
            },{
                name : '第11-50名',
                reward: ['C001','C004'],
                itemname : ['2000绑定梦三币','勋章*威震华夏（30天）']                  
            },{
                name : '第51-160名',
                reward: ['C001','C004'],
                itemname : ['1000绑定梦三币','勋章*威震华夏（30天）']                  
            }],              
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        document.addEventListener('touchmove', this.stopTouch, this.opt); // 禁止页面滑动              
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            document.body.style.overflow = ''; // 出现滚动条
            document.removeEventListener('touchmove', this.stopTouch, this.opt);     

            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },      
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/RankRewardModal/rankRewardModal.vue